export default [
  {
    path: '/parametrizacao-financeiro',
    name: 'parametrizacaofinanceiro',
    component: () => import('@/app-modulo/comercial/Parametrizacao/ParametrizacaoFinanceiro/Geral/ParametrizacaoFinanceiro.vue'),
    meta: {
      resource: 'parametrizacaogeral',
      action: 'create',
      pageTitle: 'Configurações — Relatório Financeiro',
      breadcrumb: [],
    },
  },
]
